import React from "react";
import { Column, Columns, Table, TextArea } from "@allxsmith/bestax-bulma";
import {formatDate, getPhoneNumber, readableDate} from "../../utils";



class PrintMovementNote extends React.Component {


    render(){
        let data = this.props.movement;
        // Some variables are too long to put in line as ifs so they will be handled here
        let vehicle_used_make = (data && data.vehicle_used && data.vehicle_used.make) ? data.vehicle_used.make.name : null;
        let vehicle_used_model = (data && data.vehicle_used && data.vehicle_used.model) ? data.vehicle_used.model.name : null;
        let vehicle_used_make_model = (vehicle_used_make && vehicle_used_model) ? vehicle_used_make + " / " + vehicle_used_model : "";

        // if movement_performer is different to movement department then movement department is the customer
        let customer = (data && data.movement_performer && data.department) && (data.movement_performer.id === data.department.id ? (data.customer.is_cash_sale ? (data.cash_sale[0] ? data.cash_sale[0].name : "") : data.customer.display_name) : data.department.name)

        return (
            <div className={"print-portrait"}>
                <Columns isMultiline>
                  <Column>
                      <Table isFullwidth isBordered>
                          <tbody>
                            <tr>
                                <td colSpan={12} className={"table-header-bold border-black fill-grey"}>{(data && data.movement_performer) ? data.movement_performer.name : ""}</td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"table-header-bold border-black fill-grey"}>VEHICLE COLLECTION / DELIVERY NOTE</td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"table-header-bold border-black fill-grey"}>Vehicle & Driver Details</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Driver Name:</td>
                                <td colSpan={4} className={"wide-column border-black"} data-testid={"driver"}>{(data && data.driver) ? data.driver.name : ""}</td>
                                <td colSpan={2} className={"border-black fill-grey"}>Vehicle Used Registration:</td>
                                <td colSpan={4} className={"wide-column border-black"} data-testid={"vehicle-used"}>{(data && data.vehicle_used) ? data.vehicle_used.registration : ""}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Start Time:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                                <td colSpan={2} className={"border-black fill-grey"}>Finish Time:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Start Mileage:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                                <td colSpan={2} className={"border-black fill-grey"}>Finished Mileage:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Fuel:</td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={2} className={"border-black fill-grey"}>Adblue:</td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Safety Checks:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                                <td colSpan={2} className={"border-black fill-grey"}>Photos Taken:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"table-header-bold border-black fill-grey"}>COLLECTION / DELIVERY INFORMATION</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Date:</td>
                                <td colSpan={10} className={"wide-column border-black"} data-testid={"delivery-date"}>{(data && data.delivery_date) ? readableDate(data.delivery_date) : ""}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Job Number:</td>
                                <td colSpan={4} className={"wide-column border-black"} data-testid={"order-id"}>{data ? data.id : ""}</td>
                                <td colSpan={2} className={"border-black fill-grey"}>Vehicle Reg:</td>
                                <td colSpan={4} className={"wide-column border-black"} data-testid={"vehicle-reg"}>{data ? data.vehicle : ""}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Customer Order Number:</td>
                                <td colSpan={10} className={"wide-column border-black"} data-testid={"order-number"}>{data ? data.order_number : ""}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Customer:</td>
                                <td colSpan={10} className={"wide-column border-black"} data-testid={"customer"}>{customer}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Contact Number:</td>
                                <td colSpan={10} className={"wide-column border-black"} data-testid={"customer-phone"}>{(data && data.customer) ? getPhoneNumber(data.customer) : ""}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}></td>
                                <td colSpan={10} className={"wide-column out-border-middle-left-black out-border-middle-right-black out-border-top-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Collection Address:</td>
                                <td colSpan={10} className={"wide-column out-border-middle-left-black out-border-middle-right-black"} data-testid={"start-address"}>{data ? data.start_address : ""}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}></td>
                                <td colSpan={10} className={"wide-column out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Print Name:</td>
                                <td colSpan={4} className={"border-black wide-column"}></td>
                                <td colSpan={2} className={"border-black fill-grey"}>Signature:</td>
                                <td colSpan={4} className={"border-black wide-column"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"fill-grey border-black"}>I acknowledge that I have read, understand, and agree to the Terms and Conditions. Which can be found on our web site www.dvrdeliveries.co.uk</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}></td>
                                <td colSpan={10} className={"wide-column out-border-middle-left-black out-border-middle-right-black out-border-top-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Delivery Address</td>
                                <td colSpan={10} className={"wide-column out-border-middle-left-black out-border-middle-right-black"} data-testid={"end-address"}>{data ? data.end_address : ""}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}></td>
                                <td colSpan={10} className={"wide-column out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"border-black fill-grey"}>Print Name:</td>
                                <td colSpan={4} className={"border-black wide-column"}></td>
                                <td colSpan={2} className={"border-black fill-grey"}>Signature:</td>
                                <td colSpan={4} className={"border-black wide-column"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"fill-grey border-black"}>I acknowledge that I have read, understand, and agree to the Terms and Conditions. Which can be found on our web site www.dvrdeliveries.co.uk</td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"table-header-bold fill-grey border-black"}>Internal Comments</td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"border-black"}>
                                    <TextArea
                                        readOnly={true}
                                        value={data ? data.comments : ""}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"out-border-middle-black out-border-bottom-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"table-header-bold fill-grey border-black"}>Vehicle Condition</td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"out-border-middle-black out-border-top-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"out-border-middle-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"out-border-middle-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"out-border-middle-black out-border-bottom-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"table-header-bold fill-grey border-black"}>Collection And Delivery Comments</td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"border-black"}>
                                    <TextArea
                                        value={data ? data.supplier_comments : ""}
                                        readOnly={true}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"out-border-middle-black out-border-bottom-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"table-header-bold fill-grey border-black"}>Customer & Customer's Vehicle Details</td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"fill-grey border-black"}>Key Present:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                                <td colSpan={2} className={"fill-grey border-black"}>Make & Model:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"fill-grey border-black"}>ODO Reading:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                                <td colSpan={2} className={"fill-grey border-black"}>Photos Taken:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"fill-grey border-black"}>Fuel:</td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={2} className={"fill-grey border-black"}>Adblue:</td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                                <td colSpan={1} className={"border-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"table-header-bold fill-grey border-black"}>(FOR OFFICE USE)</td>
                            </tr>
                            <tr>
                                <td colSpan={12} className={"table-header-bold fill-grey border-black"}>Payment Information</td>
                            </tr>
                            <tr>
                                <td colSpan={3} className={"fill-grey border-black"}>Cash:</td>
                                <td colSpan={3} className={"fill-grey border-black"}>Card:</td>
                                <td colSpan={3} className={"fill-grey border-black"}>Bacs:</td>
                                <td colSpan={3} className={"fill-grey border-black"}>Account:</td>
                            </tr>
                            <tr>
                                <td colSpan={3} className={"wide-column out-border-top-black out-border-middle-black"}></td>
                                <td colSpan={3} className={"wide-column out-border-top-black out-border-middle-black"}></td>
                                <td colSpan={3} className={"wide-column out-border-top-black out-border-middle-black"}></td>
                                <td colSpan={3} className={"wide-column out-border-top-black out-border-middle-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={3} className={"wide-column out-border-bottom-black out-border-middle-black"}></td>
                                <td colSpan={3} className={"wide-column out-border-bottom-black out-border-middle-black"}></td>
                                <td colSpan={3} className={"wide-column out-border-bottom-black out-border-middle-black"}></td>
                                <td colSpan={3} className={"wide-column out-border-bottom-black out-border-middle-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"fill-grey border-black"}>Invoice Number:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                                <td colSpan={2} className={"fill-grey border-black"}>Defect Created:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"fill-grey border-black"}>Agreed Price:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                                <td colSpan={2} className={"fill-grey border-black"}>Approved:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                            </tr>
                            <tr>
                                <td colSpan={2} className={"fill-grey border-black"}>Sub Contractors Price:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                                <td colSpan={2} className={"fill-grey border-black"}>Expenses Number:</td>
                                <td colSpan={4} className={"wide-column border-black"}></td>
                            </tr>
                          </tbody>
                      </Table>
                  </Column>
                </Columns>
            </div>
        );
    }

}
export default PrintMovementNote;